import React from 'react';
import { Box, Paper, Stack, Button } from '@mui/material';
import { Security, Edit, Save, Cancel as CancelIcon } from '@mui/icons-material';
import Editor from '@monaco-editor/react';
import { getLanguageConfig } from '../../../../../utils/code/languageConfig';

/**
 * 秘密测试用例编辑器组件
 * 仅教师可见和编辑
 */
function SecretTestEditor({
  question,
  testCode,
  onTestCodeChange,
  editing,
  onEdit,
  onSave,
  onCancel,
  onRun,
  running = false,
  saving = false
}) {
  const displayCode = editing ? testCode : (question?.secretTestCode || '');
  const language = question ? getLanguageConfig(question.language || 'python').monacoLanguage : 'python';

  const editorOptions = {
    readOnly: !editing,
    domReadOnly: !editing,
    minimap: { enabled: false },
    fontSize: 13,
    lineNumbers: 'on',
    lineNumbersMinChars: 3,
    scrollBeyondLastLine: false,
    automaticLayout: true,
    tabSize: 4,
    wordWrap: 'off',
    fontFamily: "'Monaco', 'Menlo', 'Consolas', 'Courier New', monospace",
    renderWhitespace: 'selection',
    bracketPairColorization: { enabled: true },
    lineHeight: 19,
    letterSpacing: 0.5,
    scrollbar: {
      vertical: 'auto',
      horizontal: 'auto'
    },
    cursorStyle: 'line-thin',
    contextmenu: editing,
    quickSuggestions: editing,
    parameterHints: { enabled: editing },
    suggestOnTriggerCharacters: editing,
    acceptSuggestionOnEnter: editing ? 'on' : 'off',
    tabCompletion: editing ? 'on' : 'off',
    wordBasedSuggestions: editing
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          flexGrow: 1,
          position: 'relative',
          bgcolor: editing ? 'white' : '#fff3cd',
          overflow: 'hidden',
          p: 2
        }}
      >
        <Editor
          height="100%"
          language={language}
          value={displayCode}
          onChange={onTestCodeChange}
          theme="light"
          options={editorOptions}
        />
      </Box>
      <Paper
        sx={{
          px: 2,
          py: 0.5,
          borderRadius: 0,
          bgcolor: 'grey.100',
          borderTop: 1,
          borderColor: 'divider',
          minHeight: 36,
          display: 'flex',
          alignItems: 'center'
        }}
        elevation={0}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => onRun('secret')}
            disabled={running}
            color="secondary"
            startIcon={<Security />}
          >
            {running ? 'Running...' : 'Run with secret test'}
          </Button>
          <Stack direction="row" spacing={1}>
            {!editing ? (
              <Button
                size="small"
                startIcon={<Edit />}
                onClick={onEdit}
              >
                编辑
              </Button>
            ) : (
              <>
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<Save />}
                  onClick={onSave}
                  disabled={saving}
                >
                  保存
                </Button>
                <Button
                  size="small"
                  startIcon={<CancelIcon />}
                  onClick={onCancel}
                  disabled={saving}
                >
                  取消
                </Button>
              </>
            )}
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}

export default SecretTestEditor;

